import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS from 'reactcss';
import Panel from '@ux/panel';
import { withUniqueId } from '@team-griffin/react-unique-id';
import { Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { ReduxFormSwitch } from '@ux/switch';
import { getStyles } from '@ux/style-utils';
import stylesheet from './CookieToggle.stylesheet';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  canOptOut: props.canOptOut,
});

const PureCookieToggle = ({
  theme,
  styles,
  name,
  canOptOut,
  id,
}) => (
  <label
    style={styles.root}
    htmlFor={id}
  >
    <Panel
      theme={theme}
      style={styles.panel}
    >
      <div style={styles.toggle}>
        <h3 style={styles.title}>
          <FormattedMessage id={`cookie.toggle.${name}.title`}/>
        </h3>

        <If condition={canOptOut}>
          <Field
            name={name}
            id={id}
            component={ReduxFormSwitch}
            theme={theme}
          />
        </If>
      </div>
      <p style={styles.text}>
        <FormattedMessage id={`cookie.toggle.${name}.text`}/>
      </p>
    </Panel>
  </label>
);


export const enhance = compose(
  setDisplayName('CookieToggle'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
  withUniqueId({
    prefix: 'cookie_',
  }),
);

export default enhance(PureCookieToggle);
